<template>
 <div style="background-color:">
   <!-- <About/> -->
   <Introduction/>
 </div>
</template>
<script>
// import store from "../../store";
// import About from './About'
import Introduction from './Introduction'
export default {
  // computed: {
  //   appUser() {
  //     return store.state.isLoggedIn;
  //   },
  // },
  components: {
    // About,
    Introduction,
  }
}
</script>